import moment from 'moment-timezone';

export const DELIVERY_DOCUMENTS_PERMISSION = 'ManageRawMilkDeliveryDocuments';

export const DELIVERY_STATUS_OPTIONS = [
    { id: 'delivery', name: 'Delivered' },
    { id: 'delivery_in_progress', name: 'Delivery in Progress' },
];

export const REPORT_FILTER_OPTIONS = [
    { id: 'has_report', name: 'Has report' },
    { id: 'no_report', name: 'No report' },
];

export const REPORT_TYPE_LABELS = { delivery: 'Delivery', pre_delivery: 'Pre-delivery' };
export const UNTRACKED_REPORT_TYPE = 'Untracked';

export const reportTypeLabel = (document) => (document ? REPORT_TYPE_LABELS[document.report_type] ?? UNTRACKED_REPORT_TYPE : '-');

export const deliveryStatusLabel = (status) => DELIVERY_STATUS_OPTIONS.find((option) => option.id === status)?.name ?? '-';

export const deliveryDocumentLabel = (row) => row.BOL || 'No LT Number';

export const deliveryDocumentFilename = (row) => `${deliveryDocumentLabel(row)} - Delivery Report v${row.document?.version ?? 0} - ${moment(row.created_at).format('YYYY-MM-DD')}.pdf`;

export const deliveryDocumentVersionFilename = (row, version) => `${deliveryDocumentLabel(row)} - Delivery Report v${version} - ${moment(row.created_at).format('YYYY-MM-DD')}.pdf`;

export const MAX_ZIP_DOCUMENTS = 2000;
